webpackJsonp([80208421119915],{

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _utils = __webpack_require__(31);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'An estate (or decedent estate) or succession is a legal entity created as a result of a person\'s death. The estate consists of the real estate and/or personal property of the deceased person. The estate pays any debts owed by the decedent, and distributes the balance of the estate\'s assets to the beneficiaries of the estate'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Deceased Individual Information',
	  fields: new Map([['deceasedFirstName', {
	    component: _components.TextInput,
	    label: 'First Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Deceased Information',
	    'data-help-text': 'Enter information of the Deceased individual.',
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['deceasedMiddleName', {
	    component: _components.TextInput,
	    label: 'Middle Name',
	    placeholder: 'Optional',
	    'data-help-title': 'Deceased Information',
	    'data-help-text': 'Enter information of the Deceased individual.',
	    validation: Yup.string()
	  }], ['deceasedLastName', {
	    component: _components.TextInput,
	    label: 'Last Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Deceased Information',
	    'data-help-text': 'Enter information of the Deceased individual.',
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['deceasedSocialSecurity', {
	    component: _components.SSNField,
	    label: 'Social Security Number',
	    placeholder: '123-45-6789',
	    title: 'Please provide a valid Social Security Number Ex: 123-45-6789',
	    'data-help-title': 'Deceased Information',
	    'data-help-text': 'Enter information of the Deceased individual.',
	    validation: Yup.string().min(11, 'Please provide a valid Social Security Number Ex: 123-45-6789').test('ssn-is-valid', 'Please provide a valid Social Security Number Ex: 123-45-6789', _utils.checkSSN).required('Please provide a valid Social Security Number Ex: 123-45-6789')
	  }], ['deceasedVerifySocialSecurity', {
	    component: _components.SSNField,
	    label: 'Verify SSN',
	    placeholder: '123-45-6789',
	    title: 'Please verify the Social Security Number',
	    'data-help-title': 'Deceased Information',
	    'data-help-text': 'Enter information of the Deceased individual.',
	    validation: Yup.string().oneOf([Yup.ref('deceasedSocialSecurity'), null], 'Please verify the Social Security Number').required('Please verify the Social Security Number')
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Executor/Personal Representative Information',
	  fields: new Map([['executorFirstName', {
	    component: _components.TextInput,
	    label: 'First Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Executor Information',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['executorMiddleName', {
	    component: _components.TextInput,
	    label: 'Middle Name',
	    placeholder: 'Optional',
	    'data-help-title': 'Executor Information',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string()
	  }], ['executorLastName', {
	    component: _components.TextInput,
	    label: 'Last Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Executor Information',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['executorSocialSecurity', {
	    component: _components.SSNField,
	    label: 'Social Security Number',
	    placeholder: '123-45-6789',
	    title: 'Please provide a valid Social Security Number Ex: 123-45-6789',
	    'data-help-title': 'Executor Information',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string().min(11, 'Please provide a valid Social Security Number Ex: 123-45-6789').test('ssn-is-valid', 'Please provide a valid Social Security Number Ex: 123-45-6789', _utils.checkSSN).required('Please provide a valid Social Security Number Ex: 123-45-6789')
	  }], ['executorVerifySocialSecurity', {
	    component: _components.SSNField,
	    label: 'Verify SSN',
	    placeholder: '123-45-6789',
	    title: 'Please verify the Social Security Number',
	    'data-help-title': 'Executor Information',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string().oneOf([Yup.ref('executorSocialSecurity'), null], 'Please verify the Social Security Number').required('Please verify the Social Security Number')
	  }], ['executorTitle', {
	    initial: 'executor',
	    component: _components.SelectInput,
	    options: [{ value: 'executor', label: 'Executor' }, { value: 'administrator', label: 'Administrator' }, { value: 'personal_representative', label: 'Personal Representative' }],
	    label: 'Title',
	    title: 'Executor Information',
	    'data-help-title': 'Owner Title',
	    'data-help-text': "This is the Responsible Party for the estate. The Responsible Party is the person who has a level of control over or entitlement to the funds or assets of an estate. It may also be referred to as the estate's Executor, Administrator, or Personal Representative.",
	    validation: Yup.string().required('Please select the valid title')
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Executor/Personal Representative address (No PO Boxes)',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Estate Dates',
	  fields: new Map([['businessDateStart', {
	    label: 'Date of death'
	  }], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify']])
	}];
	
	var EstateApplicationPage = function EstateApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Estate Application',
	    documentType: _data.documentTypes.ESTATE_DECEASED_INDIVIDUAL,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = EstateApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-estate-application-js-503f3f093a79190233e1.js